export enum AggregationFunctionLabels {
    COUNT = 'Count non-null',
    SUM = 'Sum',
    AVG = 'Average',
    MIN = 'Minimum',
    MAX = 'Maximum',
    COUNTD = 'Count distinct'
}
